/** Errore 409: sede FIC proposta prima dell'invio SDI. */
export function isFicSedePropostaError(err) {
  const detail = err?.response?.data?.detail;
  return err?.response?.status === 409 && detail?.code === "FIC_SEDE_PROPOSTA";
}

export function ficSedePropostaFromError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail || detail.code !== "FIC_SEDE_PROPOSTA") return null;
  return {
    fatturaId: detail.fattura_id,
    numero: detail.numero,
    ficSede: detail.fic_sede,
    message: detail.message,
  };
}

export async function postInviaSdi(axios, apiUrl, fatturaId, { headers, strutturaId, applicaSedeFic = false } = {}) {
  const params = {};
  if (strutturaId) params.strutturaId = strutturaId;
  if (applicaSedeFic) params.applica_sede_fic = true;
  return axios.post(`${apiUrl}/api/fatturazione/fatture/${fatturaId}/invia-sdi`, {}, { headers, params });
}

export function formatFicSedeDisplay(sede) {
  if (!sede) return "";
  if (sede.indirizzo_residenza) return sede.indirizzo_residenza;
  const loc = [sede.cap, sede.citta, sede.provincia].filter(Boolean).join(" ");
  if (sede.indirizzo && loc) return `${sede.indirizzo}, ${loc}`;
  return sede.indirizzo || loc || "";
}
